<span *ngIf="substituteInstructor">
    {{substituteInstructor.name}} (substitute)
</span>
<span *ngIf="nominalInstructor && !substituteInstructor">
    {{nominalInstructor.name}}
</span>